let projectConstants = {
  addProjectFirstForm: "ADD_PROJECT_FIRST_FORM",
  addProjectSecondForm: "ADD_PROJECT_SECOND_FORM",
  addProjectThirdForm: "ADD_PROJECT_THIRD_FORM",
};
export { projectConstants };
